import type { SVGProps } from "react";

export default function RoundTo2Icon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.59722 8.73611C9.59722 7.77728 8.81993 7 7.86111 7C6.90229 7 6.125 7.77728 6.125 8.73611V12.2083C6.125 13.1672 6.90229 13.9444 7.86111 13.9444C8.81993 13.9444 9.59722 13.1672 9.59722 12.2083V8.73611Z"
        stroke="currentColor"
        strokeWidth="1.38889"
      />
      <path
        d="M15.1949 8.73611C15.1949 7.77728 14.4176 7 13.4588 7C12.4999 7 11.7227 7.77728 11.7227 8.73611V12.2083C11.7227 13.1672 12.4999 13.9444 13.4588 13.9444C14.4176 13.9444 15.1949 13.1672 15.1949 12.2083V8.73611Z"
        stroke="currentColor"
        strokeWidth="1.38889"
      />
      <path
        d="M3 13.9443H3.34722"
        stroke="currentColor"
        strokeWidth="1.38889"
        strokeLinecap="round"
      />
    </svg>
  );
}
